jQuery(document).foundation();

jQuery(document).ready(function($) {
    $('#main-nav').on(
        'show.zf.dropdownmenu', function() {
            var dropdown = $(this).find('.js-dropdown-active');
            dropdown.css('display', 'none');
            dropdown.fadeIn('fast');
        }
    );
    $('#main-nav').on(
        'hide.zf.dropdownmenu', function(ev, $el) {
            var dropdown = $($el).children('.is-dropdown-submenu' );
            dropdown.css('display', 'inherit');
            dropdown.fadeOut('fast');
        }
    );

    //  menuPlus Functionality
    $('div.menuPlus-container').on('click', function() {
        var menuPlusContainer = $(this).attr('data-menuPlus')
        $(this).find('div.menuPlus').toggleClass('active');
        $('div.menuPlus[data-menuPlus="' + menuPlusContainer + '"]').slideToggle('slow');
        console.log(menuPlusContainer);
    });
    //  Slick Functionality
    var maxHeight = -1;
    $('.slide').each(function() {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });
    $('.slide').each(function() {
        if ($(this).height() < maxHeight) {
            $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
        }
    });
    $('#slick-carousel').slick({
        nextArrow:$('.slick-next'),
        prevArrow: false,
        vertical: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 3
        //         }
        //     },
        //     {
        //         breakpoint: 600,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 2
        //         }
        //     },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1
        //         }
        //     }
        // ]
    });
    //  subscribeToBlog Functionality
    $('a[data-subscribe="subscribe"]').on('click', function(e) {
        e.preventDefault();
        $( "div.subscribe-content" ).slideToggle('slow');
    });
    $('input#mc-embedded-subscribe').on('click', function() {
        $('div.subscribe-form-container').slideToggle('slow');
        $(this).closest('form').find("input[type=text], textarea").val("");
    });
    // mobileNavLaunch-box
    $('div#offCanvas').on('opened.zf.offcanvas', function() {
        $('div.mobileNavLaunch').addClass('active');
    });
    $('div#offCanvas').on('closed.zf.offcanvas', function() {
        $('div.mobileNavLaunch').removeClass('active');
    });
});
